import { NextRouter } from "next/router";
import { AnalyticsData } from "../providers/Analytic/FeesAnalyticsDataProvider";
import { TrackEventFunction } from "../providers/Analytic/Analytic.provider";
import { goBackToComponent } from "../helpers/string-helpers";

type ApplyNowProps = {
  router?: NextRouter;
  setIsModalOpen: (isOpen: boolean) => void;
  applyNowUrl?: string;
  trackEvent: TrackEventFunction;
  eventName: string;
  eventData: AnalyticsData;
};

type CloseApplyModalProps = {
  setIsModalOpen: (isOpen: boolean) => void;
  trackEvent: TrackEventFunction;
  eventData: AnalyticsData;
  applyNowUrl?: string;
  eventName: string;
};

const applyNow = async (props: ApplyNowProps) => {
  if (props.applyNowUrl) {
    window.open(props.applyNowUrl, "_blank");
  } else {
    props.router && goBackToComponent(props.router, "contact-us");
  }

  await props.trackEvent(props.eventName, props.eventData);

  props.setIsModalOpen(false);
};

const closeModal = (props: CloseApplyModalProps) => {
  const eventData = {
    ...props.eventData,
    action_type: "interstitial-close",
    destination_url: props.applyNowUrl ?? "",
  };
  props.trackEvent(props.eventName, eventData);
  props.setIsModalOpen(false);
};

export { applyNow, closeModal };
export default applyNow;
